// Coupons page placeholder

export default function CouponsPage() {
	return null;
}
